import { Card, Grid, Box, Tab, Tabs, Typography, TextField, Modal } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useStyles } from './style';
import profileImg1 from '../../Assets/profile1.png';
import profileImg2 from '../../Assets/profile2.png';
import KenButton from '../../GlobalComponents/KenButton';
import imageIcon from '../../Assets/imageIcon.svg';
import pinIcon from '../../Assets/pinIcon.svg';
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs, { Dayjs } from 'dayjs';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import MeetIcon from '../../Assets/meetIcon.png';
import AddIcon from '@mui/icons-material/Add';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LinearProgress from '@mui/material/LinearProgress';
import AddTaskModel from './addTaskModel';
import ScheduleForm from './scheduleForm';
import ImageUpload from './imageUpload';
import { getMentorShipTask, getNetworks } from '../../Utils/apiService';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { AuthUser } from '../../interfaces/Contexts';
import MeetIcon from '../../Assets/MeetIcon.svg';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const mentee = [
  {
    name: 'Jabastin V',
    areaOfInterest: 'Mobile App Design',
    goals: 'Transition into a senior UI/UX designer role, specialize in app design',
    image: profileImg1,
    year: 'Class of 2018',
  },
  {
    name: 'Rubina Atwal',
    areaOfInterest: 'User-Centered Design',
    goals: 'Transition into a senior UI/UX designer role, specialize in app design',
    image: profileImg2,
    year: 'Class of 2018',
  },
  {
    name: 'Jaffrina Joseph',
    areaOfInterest: 'User-Centered Design',
    goals: 'Transition into a senior UI/UX designer role, specialize in app design',
    image: profileImg1,
    year: 'Class of 2018',
  },
  {
    name: 'Rubina Atwal',
    areaOfInterest: 'User-Centered Design',
    goals: 'Transition into a senior UI/UX designer role, specialize in app design',
    image: profileImg2,
    year: 'Class of 2018',
  },
];
const sceduleData = [
  {
    sceduleName: 'One - on - One session with Jabastin V ',
    startTime: '09:00',
    endTime: '10:00',
    sceduleType: 'Virtual',
    time: '09:00 AM - 10:30 AM',
  },
  {
    sceduleName: 'Alumni Awards Ceremony',
    startTime: '11:00',
    endTime: '12:00',
    sceduleType: 'Virtual',
    time: '09:00 AM - 10:30 AM',
  },
  {
    sceduleName: 'Lunch',
    startTime: '13:00',
  },
  {
    sceduleName: 'Placement Training',
    startTime: '04:00',
    endTime: '15:00',
    sceduleType: 'Virtual',
    time: '09:00 AM - 10:30 AM',
  },
];

const sendData = [
  {
    title: 'Hey',
    content: 'Sounds awesome! wait to catch up and network with fellow alumni. Count me in for the event. Thanks for the heads up, and looking forward to some great conversations.',
  },
];
const MentorDetails = () => {
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const [value, setValue] = React.useState(0);
  const [active, setActive] = useState(0);
  const classes = useStyles();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [values, setValues] = React.useState<Dayjs | null>(dayjs('2022-04-17'));
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [openSchedule, setOpenSchedule] = React.useState(false);
  const handleOpenSchedule = () => setOpenSchedule(true);
  const handleCloseSchedule = () => setOpenSchedule(false);
  const [openImage, setOpenImage] = React.useState(false);
  const handleOpenImage = () => setOpenImage(true);
  const handleCloseImage = () => setOpenImage(false);
  const [msgStatus, setMsgStatus] = useState(false);
  const [getTaskData, setGetTaskData] = useState([]);
  const [taskUpdateStatus, setTaskUpdateStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [menteeDetails, setMenteeDetails] = useState<any>([]);

  const getTaskDetail = () => {
    getMentorShipTask(userData.applicantId)
      .then((res) => {
        console.log('res68764', res);
        setGetTaskData(res.data.myTasks);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getMenteeDetails = () => {
    getNetworks(userData.applicantId)
      .then((res) => {
        console.log('reshghg', res);

        setMenteeDetails(res?.data?.myMentees);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getTaskDetail();
    getMenteeDetails();
  }, [taskUpdateStatus]);
  return (
    <Box
      sx={{
        height: '87vh',
        '@media (min-width: 1280px) and (max-width: 1300px)': {
          height: '85vh',
        },
      }}
      className="scrollbar-cusgrayHeader"
    >
      <Card
        className={`${classes.mentorDetailCard}`}
        sx={{
          '@media (min-width: 1280px) and (max-width: 1300px)': {
            height: '43vh',
          },
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
            <Box sx={{ width: '100%' }}>
              {/* <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                variant={'fullWidth'}
                sx={{
                  width: '100%',
                  '& .MuiTab-root': {
                    textTransform: 'capitalize',
                  },
                  fontSize: 20,
                }}
              >
                <Tab
                  label="Your Mentees"
                  {...a11yProps(0)}
                  sx={{
                    fontSize: 17,
                  }}
                />
                <Tab
                  label="New Request"
                  {...a11yProps(1)}
                  sx={{
                    fontSize: 17,
                  }}
                />
              </Tabs> */}
              {/* <CustomTabPanel value={value} index={0}> */}
              <Typography
                sx={{
                  fontSize: '15px',
                  textAlign: 'left',
                  fontWeight: 500,
                  m: 1,
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '13px !important',
                  },
                }}
              >
                Your Mentees
              </Typography>
              {menteeDetails?.length > 0 ? (
                <Box sx={{ height: '32vh', mt: 4 }} className="scrollbar-cusgray">
                  {menteeDetails?.map((val: any, index: number) => {
                    return (
                      <Box className={active == index ? `${classes.activeColor}` : `${classes.nonActiveColor}`} onClick={() => setActive(index)}>
                        <Typography className={classes.menteeName}>{val?.Mentee__r?.Name}</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
                            <Typography className={classes.subTitleMentee}>Area of interest: </Typography>
                            <Typography className={classes.subTitleMentee}>Career Goals: </Typography>
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={6.5} xl={6.5}>
                            <Typography className={classes.subContentMentee}>{val?.Mentee__r?.Area_of_Interest__c}</Typography>
                            <Typography className={classes.subContentMentee}>{val?.Mentee__r?.Career_Goals__c}</Typography>
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={2.5} xl={2.5}>
                            <img src={val?.Mentee__r?.Profile_Picture_URL__c} height={'60%'} width={'60%'} style={{ borderRadius: '50%' }} />
                            <Typography className={classes.menteeYear}>{val?.Mentee__r?.Year_of_Graduation__c}</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    );
                  })}
                </Box>
              ) : (
                <Box sx={{ height: '32vh', mt: 4 }} className="scrollbar-cusgray">
                  <Typography sx={{ display: 'flex', justifyContent: 'center', height: '80%', alignItems: 'center', fontSize: '15px', fontWeight: 500 }}>No data available</Typography>
                </Box>
              )}

              {/* </CustomTabPanel> */}
              {/* <CustomTabPanel value={value} index={1}>
                <Box sx={{ height: "29vh" }} className="scrollbar-cus">
                  {mentee.map((val, index) => {
                    return (
                      <Box className={active == index ? `${classes.activeColor}` : `${classes.nonActiveColor}`} onClick={() => setActive(index)}>
                        <Typography className={classes.menteeName}>{val.name}</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
                            <Typography className={classes.subTitleMentee}>Area of interest: </Typography>
                            <Typography className={classes.subTitleMentee}>Career Goals: </Typography>
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={6.5} xl={6.5}>
                            <Typography className={classes.subContentMentee}>{val.areaOfInterest}</Typography>
                            <Typography className={classes.subContentMentee}>{val.goals}</Typography>
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={2.5} xl={2.5}>
                            <img src={val.image} height={'70%'} width={'60%'} />
                            <Typography className={classes.menteeYear}>{val.year}</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    );
                  })}
                </Box>
              </CustomTabPanel> */}
            </Box>
          </Grid>
          <Grid item xs={0} sm={0} md={0} lg={0.2} xl={0.2}>
            <div className={classes.hr} />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6.8}
            xl={6.8}
            sx={{
              '@media (min-width: 1280px) and (max-width: 1300px)': {
                height: '39vh',
              },
            }}
            className="scrollbar-cusgray"
          >
            <Typography sx={{ fontSize: '15px', fontWeight: 500, textAlign: 'left' }}>{menteeDetails?.[active]?.Mentee__r?.Name}</Typography>
            <Typography sx={{ fontSize: '10.5px', fontWeight: 400, textAlign: 'left' }}>Class of 2018</Typography>
            <hr style={{ border: '1px solid #E6E6E8' }} />
            <Grid container spacing={2} className={classes.menteeDetailCard}>
              <Grid item xs={1}>
                <img src={menteeDetails?.[active]?.Mentee__r?.Profile_Picture_URL__c} height={'50%'} width={'80%'} style={{ borderRadius: '50%' }} />
              </Grid>
              <Grid item xs={11}>
                <Typography className={classes.menteeDetailName}>{menteeDetails?.[active]?.Mentee__r?.Name}</Typography>
                <Typography className={classes.menteeDetailContent}>10.59 AM</Typography>
                <Box
                  sx={{
                    height: { lg: 60, xl: 60 },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      height: '8vh !important',
                    },
                  }}
                  className="scrollbar-cusgray"
                >
                  <Typography className={classes.menteeDetailContent} sx={{ mt: 2 }}>
                    Hey {menteeDetails?.[active]?.Mentee__r?.Name},
                  </Typography>
                  <Typography className={`${classes.menteeDetailContent}`}>
                    I hope this message finds you well. I'm eager to seek your guidance in my career development. Currently a UI/UX designer, I admire your expertise in Design. Could we schedule a
                    brief call at your convenience? I'd greatly appreciate your insights on App UI/UX design. Thank you for considering; I value your time.
                  </Typography>
                  {msgStatus && (
                    <>
                      {sendData?.map((val) => {
                        return (
                          <Box sx={{ backgroundColor: '#EAEFFF', mt: 1, p: 2, borderRadius: 3, ml: 2 }}>
                            <Typography className={classes.menteeDetailContent} sx={{ mt: 2 }}>
                              {val.title}
                            </Typography>
                            <Typography className={`${classes.menteeDetailContent}`}>{val.content}</Typography>
                          </Box>
                        );
                      })}
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'start' }}>
              <Typography className={classes.menteeDetailMsg}>Yes I’m Interested!</Typography>
              <Typography className={classes.menteeDetailMsg1}>No!</Typography>
              <Typography className={classes.menteeDetailMsg2}>Maybe</Typography>
            </Box>
            <TextField
              multiline
              rows={1} // Keeps the field to a single line unless more rows are added dynamically
              placeholder="Write a message"
              variant="outlined"
              fullWidth
              size="small"
              sx={{
                mt: 2,
                borderRadius: '10px !important',
                fontSize: '12px',
                '& .MuiInputBase-input': {
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-root': {
                  minHeight: '36px',
                },
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  '& .MuiOutlinedInput-root': {
                    minHeight: '28px',
                  },
                },
              }}
            />

            <Grid container spacing={2} sx={{ mt: 0.2 }}>
              <Grid item xs={0.5} style={{ cursor: 'pointer' }}>
                <img src={imageIcon} onClick={handleOpenImage} style={{ height: '20px', width: '20px', cursor: 'pointer' }} />
                <Modal open={openImage} onClose={handleCloseImage} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                  <ImageUpload handleClose={handleCloseImage} />
                </Modal>
              </Grid>
              <Grid item xs={0.5}>
                <Box sx={{ cursor: 'pointer' }}>
                  <img src={pinIcon} style={{ marginLeft: 10, height: '20px', width: '20px' }} onClick={handleOpenImage} />
                </Box>
                <Modal open={openImage} onClose={handleCloseImage} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                  <ImageUpload handleClose={handleCloseImage} />
                </Modal>
              </Grid>
              <Grid item xs={11} sx={{ display: 'flex', justifyContent: 'end' }}>
                <KenButton
                  variant="contained"
                  style={{
                    width: '120px',
                    borderRadius: '6px',
                    height: '36px',
                    boxShadow: 'none',
                    '&:hover': {
                      boxShadow: 'none',
                    },
                    '&:active': {
                      boxShadow: 'none',
                    },
                  }}
                  fullWidth
                  onClick={() => setMsgStatus(true)}
                >
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: 600,
                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                        fontSize: '10px',
                      },
                    }}
                  >
                    Send Message
                  </Typography>
                </KenButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
      <Grid container spacing={2} sx={{ mt: 0.5 }}>
        <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
          <Card className={`${classes.mentorDetailCard} ${classes.mentorDetailBox}`}>
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['StaticDatePicker']}>
                    <DemoItem>
                      <Box
                        sx={{
                          width: '100%',
                          height: '252px',
                          overflowX: 'hidden !important',
                        }}
                        className="scrollbar-cusgray"
                      >
                        <StaticDatePicker
                          displayStaticWrapperAs="desktop"
                          value={values}
                          onChange={(newValue) => setValues(newValue)}
                          slotProps={{
                            actionBar: {
                              actions: [],
                            },
                          }}
                          sx={{
                            '& .MuiPickersDay-root.Mui-selected': {
                              backgroundColor: '#5981FF !important',
                              color: 'white !important',
                            },
                          }}
                        />
                      </Box>
                    </DemoItem>
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
                <Grid container sx={{ height: '6vh' }}>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Typography sx={{ textAlign: 'left', fontSize: '15px', fontWeight: 500, ml: 2.5, mt: 1.5 }}>12 January,2022</Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ display: 'flex', justifyContent: { xs: 'start', sm: 'start', md: 'start', lg: 'end', xl: 'end' } }}>
                    <KenButton
                      variant="contained"
                      style={{
                        width: 120,
                        borderRadius: '7px',
                        height: '27px',
                        boxShadow: 'none',
                        marginRight:"14px",
                        '&:hover': {
                          boxShadow: 'none',
                        },
                        '&:active': {
                          boxShadow: 'none',
                        },
                      }}
                      fullWidth
                      onClick={handleOpenSchedule}
                    >
                      <Typography sx={{ fontWeight: 600, fontSize: '12px' }}>Schedule a call</Typography>
                    </KenButton>
                    <Modal open={openSchedule} onClose={handleCloseSchedule} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                      <ScheduleForm handleClose={handleCloseSchedule} />
                    </Modal>
                  </Grid>
                </Grid>
                <Box sx={{ height: { lg: '29vh', xl: '29vh' } }} className="scrollbar-cusgray">
                  {sceduleData?.map((val, index) => {
                    return (
                      <Grid container sx={{ mt: 1.8 }}>
                        <Grid item xs={4} sm={4} md={4} lg={2} xl={2}>
                          <Typography sx={{ fontSize: '10.79px', fontWeight: 400 }}>{val.startTime}</Typography>
                          <Typography sx={{ mt: 4, fontSize: '10.79px', fontWeight: 400 }}>{val.endTime}</Typography>
                        </Grid>
                        <Grid
                          item
                          xs={8}
                          sm={8}
                          md={8}
                          lg={9.8}
                          xl={9.8}
                          sx={{
                            backgroundColor: index % 2 == 0 ? '#EAEFFF' : 'white',
                            border: index % 2 == 0 ? '' : '0.75px solid #2C58E8',
                            borderLeft: index % 2 == 0 ? '2px solid #2C58E8' : '',
                            borderRadius: 3,
                            p: 1,
                          }}
                        >
                          <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                              <Typography sx={{ textAlign: 'left', fontWeight: 550, fontSize: '10.5px' }}>{val.sceduleName}</Typography>
                              <Typography sx={{ textAlign: 'left', fontSize: '10.5px', fontWeight: 400 }}>{val.sceduleType}</Typography>
                              {val.time && (
                                <Box sx={{ display: 'flex', justifyContent: 'start', mb: 1 }}>
                                  <AccessTimeIcon sx={{ mt: 1.5 }} />
                                  <Typography sx={{ textAlign: 'left', fontSize: '10.5px', fontWeight: 500, mt: 1.5, ml: 1 }}>{val.time}</Typography>
                                </Box>
                              )}
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={4} xl={4} sx={{ display: 'flex', justifyContent: 'end' }}>
                              <Typography sx={{ fontSize: '10.5px', fontWeight: 500, mt: 1 }}>Reschedule</Typography>
                              <Typography sx={{ ml: 2 }}>
                                <img src={MeetIcon} />
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
          <Card className={classes.mentorDetailCard}>
            <Grid container sx={{ height: '7vh' }}>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Typography sx={{ textAlign: 'left', fontSize: '15px', fontWeight: 500, mt: 1.5, ml: 1 }}>Task</Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                <KenButton
                  variant="contained"
                  style={{
                    width: 100,
                    borderRadius: '6px',
                    height: '27px',
                    boxShadow: 'none',
                    '&:hover': {
                      boxShadow: 'none',
                    },
                    '&:active': {
                      boxShadow: 'none',
                    },
                    marginRight: '8px',
                  }}
                  fullWidth
                  onClick={handleOpen}
                >
                  <AddIcon style={{ fontSize: '15px' }} /> <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>Add Task</Typography>
                </KenButton>
                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                  <AddTaskModel handleClose={handleClose} setTaskUpdateStatus={setTaskUpdateStatus} name={'add'} />
                </Modal>
              </Grid>
            </Grid>
            <Box
              sx={{
                width: '100%',
                height: { lg: '27vh', xl: '27vh' },
                '@media (min-width: 1536px) and (max-width: 1636px)': {
                  height: '25.8vh !important',
                },
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  height: '24vh !important',
                },
                '@media (min-width: 1920px) and (max-width: 1940px)': {
                  height: '31.7vh !important',
                },
              }}
              className="scrollbar-cusgray"
            >
              {getTaskData?.map((val: any) => {
                return (
                  <Box sx={{ backgroundColor: val.Status == 'Completed' ? '#EBF4EC' : '#FFF9EA', borderRadius: 3, p: 2, mt: 1, ml: 0.5 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
                        <Typography sx={{ textAlign: 'left', fontSize: '12px', fontWeight: 500 }}>
                          Task: <span style={{ marginLeft: 5, fontWeight: 400 }}>{val.Subject}</span>
                        </Typography>
                        <Typography sx={{ textAlign: 'left', fontSize: '12px', fontWeight: 500 }}>
                          End Date: <span style={{ marginLeft: 5, fontWeight: 400 }}>{val.ActivityDate}</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={3} xl={3} style={{ display: 'flex', justifyContent: 'end' }}>
                        <DeleteOutlineOutlinedIcon />
                        <ModeEditOutlineOutlinedIcon sx={{ ml: 3, cursor: 'pointer' }} onClick={handleOpen1} />
                      </Grid>
                      <Modal open={open1} onClose={handleClose1} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <AddTaskModel handleClose={handleClose1} setTaskUpdateStatus={setTaskUpdateStatus} name={'edit'} />
                      </Modal>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={12} lg={10.5} xl={10.5}>
                        <Box sx={{ width: '100%', mt: 1 }}>
                          <LinearProgress
                            variant="determinate"
                            value={val.Status == 'Completed' ? 100 : 50}
                            sx={{
                              mt: 1.1,
                              height: '3px',
                              borderRadius: 5,
                              backgroundColor: val.Status == 'Completed' ? '#C1DCC3' : '#FEEBBE',
                              '& .MuiLinearProgress-bar': {
                                borderRadius: 5,
                                backgroundColor: val.Status == 'Completed' ? '#338137' : '#E4AF29',
                              },
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={1.5} xl={1.5}>
                        <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>{val.Status == 'Completed' ? '100%' : '50%'}</Typography>
                      </Grid>
                    </Grid>
                  </Box>
                );
              })}
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MentorDetails;
